import { format } from 'date-fns'
import { api } from '../services/api'
import { formatPrice } from '../utils/formatPrice'

export class DadosOrcamentoPedidoService {
  constructor() {
    this.api = api
  }

  async getItems({ numeroProposta }) {
    const response = await api.get(`/site/v2/orcamento-crm/listar-dados-parceiro/${numeroProposta}`)

    response.data.itens = response.data.itens.map((item, index) => {
      return {
        ...item,
        codigo_cor: parseInt(item.codigo_cor),
        id_impressao: parseInt(item.id_impressao),
        quantidade: String(item.quantidade),
        qtd_batida: parseInt(item.qtd_batida) || 0,
        id_personalizacao: parseInt(item.id_personalizacao),
        prazo: parseInt(item.prazo) || 0,
        id: `${item.codigo_produto}-${parseInt(Math.random() * 1000 * index)}`,
        impressoes: item.impressoes.map((impressao) => {
          return {
            value: parseInt(impressao.qtd_batida),
            label: `${impressao.qtd_batida} impressões`,
          }
        }),
        personalizacao: item.personalizacao.map((personalizacao) => {
          return {
            value: parseInt(personalizacao.id_personalizacao),
            label: personalizacao.nome_personalizacao,
            caricatura: personalizacao.caricatura_ativa,
          }
        }),
        prazos: item.prazos.map((prazo) => {
          return {
            value: parseInt(prazo.prazo),
            label: `${prazo.prazo} dias úteis`,
          }
        }),
        cores: item.cores.map((cor) => {
          return {
            ...cor,
            value: parseInt(cor.codigo_cor),
            label: cor.descricao_cor,
            hex: cor.rgb_cores,
          }
        }),
        original_preco_venda: item.preco_venda,
        preco_base: formatPrice(item.preco_base),
        preco_site: formatPrice(item.preco_site),
        preco_venda: formatPrice(item.preco_venda),
        vlr_substituicao: formatPrice(item.vlr_substituicao),
        valor_total_itens: formatPrice(item.valor_total_itens),
        original_valor_total_itens: item.valor_total_itens,
        original_preco_site: item.preco_site,
        original_preco_base: item.preco_base,
        original_vlr_substituicao: item.vlr_substituicao,
        original_valor_total_pedido: item.valor_total_pedido,
      }
    })

    response.data.informacao_da_proposta.cliente.data_retorno = response.data.informacao_da_proposta.cliente.data_retorno
      ? format(new Date(response.data.informacao_da_proposta.cliente.data_retorno), 'dd/MM/yyyy')
      : ''

    response.data.informacao_da_proposta.tipos_funil = response.data.informacao_da_proposta.tipos_funil.map((tipo) => {
      return { value: tipo.codigo_funil_venda, label: tipo.tipo_funil_venda }
    })

    response.data.informacao_da_proposta.empresas = response.data.informacao_da_proposta.empresas.map((empresa) => {
      return { value: empresa.codigo_empresa, label: empresa.razao_social }
    })

    response.data.informacao_da_proposta.tipos_verba = response.data.informacao_da_proposta.tipos_verba.map((verba) => {
      return { value: verba.id, label: verba.valor }
    })

    response.data.informacao_da_proposta.info_tipo = response.data.informacao_da_proposta.info_tipo.map((tipo) => {
      return { value: parseInt(tipo.id_tipo), label: tipo.tipo_uso }
    })

    response.data.informacao_da_proposta.historico_pagamento = response.data.informacao_da_proposta.historico_pagamento.map((historico) => {
      return {
        ...historico,
        data_negociacao: format(new Date(historico.data_negociacao), 'dd/MM/yyyy'),
        valor_nota: formatPrice(historico.valor_nota),
        dias_atraso: historico.dias_atraso,
        original_data_negociacao: historico.data_negociacao,
        data_pagamento: format(new Date(historico.data_pagamento), 'dd/MM/yyyy'),
      }
    })

    response.data.informacao_da_proposta.total_valor_pedidos = formatPrice(response.data.informacao_da_proposta.total_valor_pedidos)

    response.data.informacao_da_proposta.dados_retorno = response.data.informacao_da_proposta.dados_retorno.map((item) => {
      return {
        ...item,
        data_contato: item.data_contato ? format(new Date(item.data_contato), "dd/MM/yyyy '|' HH:mm") : '',
        data_agendamento: item.data_agendamento ? format(new Date(item.data_agendamento), "dd/MM/yyyy '|' HH:mm") : '',
        tipo_chamado: item.tipo_chamado ?? 'Sem tipo',
      }
    })

    return response.data
  }

  async solicitarCaricatura(data) {
    const response = await api.post('/site/v2/orcamento-crm/solicita-caricatura', data)

    if (response.status !== 200) {
      throw new Error(response.data.erros)
    }

    return response.data
  }
}
